/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BenchmarkSettings } from '@coin/shared/core/util-models-v2';
import { ChangeManyPriorities } from '@coin/shared/core/util-models-v2';
import { Colorado } from '@coin/shared/core/util-models-v2';
import { CreateAre } from '@coin/shared/core/util-models-v2';
import { CreateBenchmarkSettings } from '@coin/shared/core/util-models-v2';
import { CreateMercerJobCodeAndPositionClassAssignment } from '@coin/shared/core/util-models-v2';
import { CreateMercerJobCodeAssignmentsExport } from '@coin/shared/core/util-models-v2';
import { CreateRuleBasedAccessFilterCommand } from '@coin/shared/core/util-models-v2';
import { CreateSecuritySettings } from '@coin/shared/core/util-models-v2';
import { EmployeeInternalLevel } from '@coin/shared/core/util-models-v2';
import { EmployeesAresAre } from '@coin/shared/core/util-models-v2';
import { EmployeesEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { EntitySearchScope } from '@coin/shared/core/util-models-v2';
import { FullEmployee } from '@coin/shared/core/util-models-v2';
import { FullEmployeeForReorgApp } from '@coin/shared/core/util-models-v2';
import { InternalComment } from '@coin/shared/core/util-models-v2';
import { JobProfileValues } from '@coin/shared/core/util-models-v2';
import { MercerJobCode } from '@coin/shared/core/util-models-v2';
import { MercerJobCodeAndPositionClassAssignment } from '@coin/shared/core/util-models-v2';
import { MercerJobCodeAndPositionClassAssignmentLight } from '@coin/shared/core/util-models-v2';
import { MercerJobCodeAssignmentLight } from '@coin/shared/core/util-models-v2';
import { MercerPositionClassAssignmentLight } from '@coin/shared/core/util-models-v2';
import { PageOfBenchmarkSettings } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeeDirect } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeesAresAre } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeesEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfFieldValueWithDescription } from '@coin/shared/core/util-models-v2';
import { PageOfFullEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfFullEmployeeForReorgApp } from '@coin/shared/core/util-models-v2';
import { PageOfMercerEmployeesWithAssignments } from '@coin/shared/core/util-models-v2';
import { PageOfMercerJobCode } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PopulationSimulationPage } from '@coin/shared/core/util-models-v2';
import { QueryEmployeesByRuleSetParameter } from '@coin/shared/core/util-models-v2';
import { QueryEmployeesWithExcludableGidsParameter } from '@coin/shared/core/util-models-v2';
import { RuleBasedAccessFilter } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';
import { SecuritySettings } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfBenchmarkAssignmentMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfEmployeeSecuritySettingsRecalculationMetaData } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { UpdateAre } from '@coin/shared/core/util-models-v2';
import { UpdateBenchmarkSettings } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeInCompanyManager } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeInternalLevelCommand } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeLineManager } from '@coin/shared/core/util-models-v2';
import { UpdateInternalComment } from '@coin/shared/core/util-models-v2';
import { UpdateMercerJobCodeAssignment } from '@coin/shared/core/util-models-v2';
import { UpdateMercerPositionClassAssignment } from '@coin/shared/core/util-models-v2';
import { UpdateRuleBasedAccessFilterCommand } from '@coin/shared/core/util-models-v2';
import { UpdateSecuritySettings } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface AssignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployeeParams {
  ruleId: string;
  employeeId: string;
}

export interface ChangePrioritiesBenchmarkSettingsParams {
  /** The model containing all priorities to change. */
  changeManyPriorities?: ChangeManyPriorities;
}

export interface CreateAresParams {
  /** The model to create a new are with. */
  createAre?: CreateAre;
}

export interface CreateBenchmarkSettingsParams {
  /** The model to create the new banchmark settings with. */
  createBenchmarkSettings?: CreateBenchmarkSettings;
}

export interface CreateMercerJobCodeAssignmentsParams {
  /** The model data to create the assignments with. */
  createMercerJobCodeAndPositionClassAssignment?: CreateMercerJobCodeAndPositionClassAssignment;
}

export interface CreateRuleBasedAccessFilterRuleBasedAccessFilterParams {
  /** Command Model with metadata to create RuleBasedAccessFilter */
  createRuleBasedAccessFilterCommand?: CreateRuleBasedAccessFilterCommand;
}

export interface CreateSecuritySettingsParams {
  /** The model data to create new security settings with. */
  createSecuritySettings?: CreateSecuritySettings;
}

export interface DeleteAresParams {
  /** The unique id of the are to delete. */
  id: string;
}

export interface DeleteRuleBasedAccessFilterRuleBasedAccessFilterParams {
  /**  */
  ruleId: string;
}

export interface DeleteSecuritySettingsParams {
  /** The unique id of the security settings to delete. */
  id: string;
}

export interface EmployeesAdminGetByGidEmployeesParams {
  /** The unique gid of the employee to get. */
  gid: string;
}

export interface EmployeesAdminGetEmployeesParams {
  /** The unique id of the employee to get. */
  id: string;
}

export interface EmployeesAdminQueryAresParams {
  page?: number;
  size?: number;
  /** The search text to find. */
  searchQuery?: string;
  /** The country\&#39;s ISO2 code to find. */
  countryCode?: string;
}

export interface EmployeesAdminQueryEmployeesParams {
  /** The gid to find. */
  gid?: string;
  /** The name to find. */
  name?: string;
  /** The firstname to find. */
  firstname?: string;
  /** The lastname to find. */
  lastname?: string;
  /** The place of action to find. */
  placeOfAction?: Array<string>;
  /** The orgcode to find. */
  orgCode?: string;
  page?: number;
  size?: number;
}

export interface ExportEmployeesExpertsDataEmployeesExpertsParams {
  fileName?: string;
  transactionId?: string;
}

export interface ExportJobAssignmentsDatahubParams {
  exportS3?: boolean;
  exportDataHub?: boolean;
}

export interface ExportJobCodesDatahubParams {
  exportS3?: boolean;
  exportDataHub?: boolean;
}

export interface ExportMerverJobCodeAssignmentsParams {
  /** The gid of the mercer job assignment. */
  gid?: Array<string>;
  /** The last name of the mercer job assignment. */
  lastname?: string;
  /** The first name of the mercer job assignment. */
  firstname?: string;
  /** The org code of the mercer job assignment. */
  orgCodes?: Array<string>;
  /** The org size of the mercer job assignment. */
  orgSizes?: Array<number>;
  /** The country of the mercer job assignment. */
  countries?: Array<string>;
  /** The are of the mercer job assignment. */
  areCodes?: Array<string>;
  /** The job code of the mercer job assignment. */
  jobCodes?: Array<string>;
  /** The family of the mercer job assignment. */
  familyNames?: Array<string>;
  /** The sub family of the mercer job assignment. */
  subFamilyNames?: Array<string>;
  /** The specialization of the mercer job assignment. */
  specializationNames?: Array<string>;
  /** The career level of the mercer job assignment. */
  careerLevelNames?: Array<string>;
  /** The career stream of the mercer job assignment. */
  careerStreams?: Array<string>;
  /** The position class of the mercer job assignment. */
  positionClasses?: Array<number>;
  /** The internal level of the mercer job assignment. */
  internalLevels?: Array<string>;
  /** The job code valid from date of the mercer assignment. */
  jobCodeValidFrom?: string;
  /** The job code valid to date of the mercer assignment. */
  jobCodeValidTo?: string;
  /** The job code validated of the mercer assignment. */
  jobCodeIsValidated?: Array<boolean>;
  /** The position class valid from date of the mercer assignment. */
  positionClassValidFrom?: string;
  /** The position class valid to date of the mercer assignment. */
  positionClassValidTo?: string;
  /** The position class validated of the mercer assignment. */
  positionClassIsValidated?: Array<boolean>;
  /** The additional create export model. */
  createMercerJobCodeAssignmentsExport?: CreateMercerJobCodeAssignmentsExport;
}

export interface GetAresParams {
  /** The unique id of the are to find. */
  id: string;
}

export interface GetColoradosParams {
  /** The unique id of the colorado to find. */
  id: string;
}

export interface GetCountEmployeesParams {
  /** The rule set to use to filter employees. */
  ruleSet?: RuleSet;
}

export interface GetEmployeeInternalLevelParams {
  /** The unique id of the employee to get the internal level of. */
  employeeId: string;
}

export interface GetEmployeeRowLevelSecurityParams {
  /** The unique of the employee. */
  id: string;
}

export interface GetEmployeeWithCompensationsParams {
  /** The unique id of the employee to get. */
  id: string;
}

export interface GetInternalCommentsParams {
  employeeId: string;
}

export interface GetMercerJobCodesParams {
  /** The unique id of the mercer job code to get. */
  id: string;
}

export interface GetSecuritySettingsParams {
  /** The unique id of the security settings to get. */
  id: string;
}

export interface QueryBenchmarkSettingsParams {
  page?: number;
  size?: number;
}

export interface QueryByEmployeeMercerJobCodeAssignmentsParams {
  /** The unique gid of the employee to query assignments for. */
  gid: string;
}

export interface QueryBySearchEmployeesParams {
  page?: number;
  size?: number;
  /** Search parameter. */
  search?: string;
}

export interface QueryDirectsInCompanyManagersParams {
  /** Optional unique id of the in company manager to find directs of. */
  id?: string;
  /** Optional gid of the in company manager to find directs of. */
  gid?: string;
  page?: number;
  size?: number;
}

export interface QueryDirectsLineManagersParams {
  /** Optional unique id of the line manager to find directs of. */
  id?: string;
  /** Optional gid of the line manager to find directs of. */
  gid?: string;
  /** The search text to filter directs with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface QueryEmployeeRowLevelSecurityParams {
  /** The gid to find. */
  gid?: string;
  /** The name to find. */
  name?: string;
  /** The orgcode to find. */
  orgCode?: string;
  /** The contract state values to filter for. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
}

export interface QueryEmployeesEmployeesParams {
  /** The query parameters and rule set to query employees with. */
  queryEmployeesByRuleSetParameter?: QueryEmployeesByRuleSetParameter;
}

export interface QueryFieldValuesEmployeesParams {
  /** The name of the field to get values for. */
  fieldname: string;
}

export interface QueryFieldValuesMercerJobCodeAssignmentsParams {
  /** The target property of the mercer job code assignment. */
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18;
  /** The organization code of the mercer job code assignment. */
  orgCode?: string;
  /** The org size of the mercer assignment. */
  orgSize?: number;
  /** The country of the mercer job code assignment. */
  country?: string;
  /** The area of responsibility of the mercer job code assignment. */
  are?: string;
  /** The job code of the mercer job code assignment. */
  jobCode?: string;
  /** The valid from of the mercer job code assignment. */
  jobCodeValidFrom?: string;
  /** The valid to of the mercer job code assignment. */
  jobCodeValidTo?: string;
  /** The Mercer family name of the mercer job code assignment. */
  familyName?: string;
  /** The Mercer sub family name of the mercer job code assignment. */
  subFamilyName?: string;
  /** The Mercer specialization name of the mercer job code assignment. */
  specializationName?: string;
  /** The Mercer career stream of the mercer job code assignment. */
  careerStream?: string;
  /** The Mercer career level name of the mercer job code assignment. */
  careerLevelName?: string;
  /** The validation state of the mercer job code assignment. */
  jobCodeIsValidated?: boolean;
  /** The Mercer position class of the mercer job code assignment. */
  positionClass?: string;
  /** The valid from of the mercer position class assignment. */
  positionClassValidFrom?: string;
  /** The valid to of the mercer position class assignment. */
  positionClassValidTo?: string;
  /** The validation state of the mercer position class assignment. */
  positionClassIsValidated?: boolean;
  /** The Mercer internal level of the mercer job code assignment. */
  internalLevel?: string;
  page?: number;
  size?: number;
}

export interface QueryFieldValuesMercerJobCodesParams {
  /** The target property of the mercer job code field value. */
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The job code of the mercer job code. */
  jobCode?: string;
  /** The family of the mercer job code. */
  family?: string;
  /** The family of the mercer job code. */
  familyEq?: string;
  /** The family code of the mercer job code. */
  familyCode?: string;
  /** The sub family of the mercer job code. */
  subFamily?: string;
  /** The sub family of the mercer job code. */
  subFamilyEq?: string;
  /** The sub family code of the mercer job code. */
  subFamilyCode?: string;
  /** The specialization of the mercer job code. */
  specialization?: string;
  /** The specialization of the mercer job code. */
  specializationEq?: string;
  /** The specialization code of the mercer job code. */
  specializationCode?: string;
  /** The career stream of the mercer job code. */
  careerStream?: string;
  /** The career stream of the mercer job code. */
  careerStreamEq?: string;
  /** The career level of the mercer job code. */
  careerLevel?: string;
  /** The career level of the mercer job code. */
  careerLevelEq?: string;
  /** The career level short of the mercer job code. */
  careerLevelShort?: string;
  /** The career level short of the mercer job code. */
  careerLevelShortEq?: string;
  /** Flag if it should be a partial job code. */
  partialJobCode?: boolean;
  page?: number;
  size?: number;
}

export interface QueryFieldValuesWithDescriptionMercerJobCodesParams {
  /** The target property of the mercer job code field value. */
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The job code of the mercer job code. */
  jobCode?: string;
  /** The family of the mercer job code. */
  family?: string;
  /** The family of the mercer job code. */
  familyEq?: string;
  /** The family code of the mercer job code. */
  familyCode?: string;
  /** The sub family of the mercer job code. */
  subFamily?: string;
  /** The sub family of the mercer job code. */
  subFamilyEq?: string;
  /** The sub family code of the mercer job code. */
  subFamilyCode?: string;
  /** The specialization of the mercer job code. */
  specialization?: string;
  /** The specialization of the mercer job code. */
  specializationEq?: string;
  /** The specialization code of the mercer job code. */
  specializationCode?: string;
  /** The career stream of the mercer job code. */
  careerStream?: string;
  /** The career stream of the mercer job code. */
  careerStreamEq?: string;
  /** The career level of the mercer job code. */
  careerLevel?: string;
  /** The career level of the mercer job code. */
  careerLevelEq?: string;
  /** The career level short of the mercer job code. */
  careerLevelShort?: string;
  /** The career level short of the mercer job code. */
  careerLevelShortEq?: string;
  /** Flag if it should be a partial job code. */
  partialJobCode?: boolean;
}

export interface QueryJobProfileValuesMercerJobCodesParams {
  /** The job code of the mercer job code. */
  jobCode?: string;
  /** The family of the mercer job code. */
  family?: string;
  /** The family of the mercer job code. */
  familyEq?: string;
  /** The family code of the mercer job code. */
  familyCode?: string;
  /** The sub family of the mercer job code. */
  subFamily?: string;
  /** The sub family of the mercer job code. */
  subFamilyEq?: string;
  /** The sub family code of the mercer job code. */
  subFamilyCode?: string;
  /** The specialization of the mercer job code. */
  specialization?: string;
  /** The specialization of the mercer job code. */
  specializationEq?: string;
  /** The specialization code of the mercer job code. */
  specializationCode?: string;
  /** The career stream of the mercer job code. */
  careerStream?: string;
  /** The career stream of the mercer job code. */
  careerStreamEq?: string;
  /** The career level of the mercer job code. */
  careerLevel?: string;
  /** The career level of the mercer job code. */
  careerLevelEq?: string;
  /** The career level short of the mercer job code. */
  careerLevelShort?: string;
  /** The career level short of the mercer job code. */
  careerLevelShortEq?: string;
  /** Flag if it should be a partial job code. */
  partialJobCode?: boolean;
}

export interface QueryMercerJobCodeAssignmentsParams {
  /** The gid of the mercer job assignment. */
  gid?: Array<string>;
  /** The last name of the mercer job assignment. */
  lastname?: string;
  /** The first name of the mercer job assignment. */
  firstname?: string;
  /** The org code of the mercer job assignment. */
  orgCodes?: Array<string>;
  /** The org size of the mercer job assignment. */
  orgSizes?: Array<number>;
  /** The country of the mercer job assignment. */
  countries?: Array<string>;
  /** The are of the mercer job assignment. */
  areCodes?: Array<string>;
  /** The job code of the mercer job assignment. */
  jobCodes?: Array<string>;
  /** The family of the mercer job assignment. */
  familyNames?: Array<string>;
  /** The sub family of the mercer job assignment. */
  subFamilyNames?: Array<string>;
  /** The specialization of the mercer job assignment. */
  specializationNames?: Array<string>;
  /** The career level of the mercer job assignment. */
  careerLevelNames?: Array<string>;
  /** The career stream of the mercer job assignment. */
  careerStreams?: Array<string>;
  /** The position class of the mercer job assignment. */
  positionClasses?: Array<number>;
  /** The internal level of the mercer job assignment. */
  internalLevels?: Array<string>;
  /** The job code valid from date of the mercer assignment. */
  jobCodeValidFrom?: string;
  /** The job code valid to date of the mercer assignment. */
  jobCodeValidTo?: string;
  /** The job code validated of the mercer assignment. */
  jobCodeIsValidated?: Array<boolean>;
  /** The position class valid from date of the mercer assignment. */
  positionClassValidFrom?: string;
  /** The position class valid to date of the mercer assignment. */
  positionClassValidTo?: string;
  /** The position class validated of the mercer assignment. */
  positionClassIsValidated?: Array<boolean>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface QueryMercerJobCodesParams {
  /** The job code of the mercer job code. */
  jobCode?: string;
  /** The family of the mercer job code. */
  family?: string;
  /** The family of the mercer job code. */
  familyEq?: string;
  /** The family code of the mercer job code. */
  familyCode?: string;
  /** The sub family of the mercer job code. */
  subFamily?: string;
  /** The sub family of the mercer job code. */
  subFamilyEq?: string;
  /** The sub family code of the mercer job code. */
  subFamilyCode?: string;
  /** The specialization of the mercer job code. */
  specialization?: string;
  /** The specialization of the mercer job code. */
  specializationEq?: string;
  /** The specialization code of the mercer job code. */
  specializationCode?: string;
  /** The career stream of the mercer job code. */
  careerStream?: string;
  /** The career stream of the mercer job code. */
  careerStreamEq?: string;
  /** The career level of the mercer job code. */
  careerLevel?: string;
  /** The career level of the mercer job code. */
  careerLevelEq?: string;
  /** The career level short of the mercer job code. */
  careerLevelShort?: string;
  /** The career level short of the mercer job code. */
  careerLevelShortEq?: string;
  /** Flag if it should be a partial job code. */
  partialJobCode?: boolean;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SearchEmployeesEmployeesParams {
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  /** Query employees parameter. */
  queryEmployeesWithExcludableGidsParameter?: QueryEmployeesWithExcludableGidsParameter;
}

export interface SimulatePopulationBenchmarkSettingsParams {
  id: string;
  page?: number;
  size?: number;
  /** The ruleset to use to simulate a population. */
  ruleSet?: RuleSet;
}

export interface SimulatePopulationSecuritySettingsParams {
  /** The unique id of the security settings to create a population simulation for. */
  id: string;
  page?: number;
  size?: number;
  /** The optional ruleset to create the population simulation with. */
  ruleSet?: RuleSet;
}

export interface UnassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployeeParams {
  ruleId: string;
  employeeId: string;
}

export interface UpdateAresParams {
  /** The model to update an existing are with. */
  updateAre?: UpdateAre;
}

export interface UpdateBenchmarkSettingsParams {
  /** The unique id of the benchmark settings to update. */
  id: string;
  /** The model to update the benchmark settings with. */
  updateBenchmarkSettings?: UpdateBenchmarkSettings;
}

export interface UpdateEmployeeInCompanyManagerParams {
  /** The unique id of the employee to update the in company manager of. */
  employeeId: string;
  /** The model to update the in company manager with. */
  updateEmployeeInCompanyManager?: UpdateEmployeeInCompanyManager;
}

export interface UpdateEmployeeInternalLevelParams {
  /** The unique id of the employee to create or update the internal level of. */
  employeeId: string;
  /** The model data to create or update the employee\&#39;s internal level with. */
  updateEmployeeInternalLevelCommand?: UpdateEmployeeInternalLevelCommand;
}

export interface UpdateEmployeeLineManagerParams {
  /** The unique id of the employee to update the line manager of. */
  employeeId: string;
  /** The model to update the line manager with. */
  updateEmployeeLineManager?: UpdateEmployeeLineManager;
}

export interface UpdateInternalCommentsParams {
  employeeId: string;
  /** The data to set the internal comment with. */
  updateInternalComment?: UpdateInternalComment;
}

export interface UpdateMercerJobCodeAssignmentMercerJobCodeAssignmentsParams {
  /** The unique id of the employee to update the assignment of. */
  employeeId: string;
  /** The unique id of the assignment to update. */
  id: string;
  /** The model data to update the assignment with. */
  updateMercerJobCodeAssignment?: UpdateMercerJobCodeAssignment;
}

export interface UpdateMercerPositionClassAssignmentMercerJobCodeAssignmentsParams {
  /** The unique id of the employee to update the assignment of. */
  employeeId: string;
  /** The unique id of the assignment to update. */
  id: string;
  /** The model data to update the assignment with. */
  updateMercerPositionClassAssignment?: UpdateMercerPositionClassAssignment;
}

export interface UpdateRuleBasedAccessFilterRuleBasedAccessFilterParams {
  /** Command Model with metadata to update RuleBasedAccessFilter */
  updateRuleBasedAccessFilterCommand?: UpdateRuleBasedAccessFilterCommand;
}

export interface UpdateSecuritySettingsParams {
  /** The unique id of the security settings to update. */
  id: string;
  /** The model data to update existing security settings with. */
  updateSecuritySettings?: UpdateSecuritySettings;
}

@Injectable({
  providedIn: 'root'
})
export class EmployeesAdminService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * Assigns benchmarks to employees.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignEmployeeBenchmarks(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfBenchmarkAssignmentMetadata>;
  public assignEmployeeBenchmarks(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfBenchmarkAssignmentMetadata>>;
  public assignEmployeeBenchmarks(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfBenchmarkAssignmentMetadata>>;
  public assignEmployeeBenchmarks(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v3/master/employees/benchmarks`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Assign RuleBasedAccessFilter to Employee
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: AssignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployeeParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public assignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: AssignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployeeParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public assignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: AssignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployeeParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public assignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: AssignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployeeParams,
    ...args: RequestArgs
  ): Observable<any> {
    const ruleId = requestParameters?.ruleId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('assignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployee', { ruleId, employeeId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/rule-based-access-filters/${this.configuration.encodeParam({ name: 'ruleId', value: ruleId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Changes specified benchmark settings priorities.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesBenchmarkSettings(
    requestParameters?: ChangePrioritiesBenchmarkSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public changePrioritiesBenchmarkSettings(
    requestParameters?: ChangePrioritiesBenchmarkSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public changePrioritiesBenchmarkSettings(
    requestParameters?: ChangePrioritiesBenchmarkSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public changePrioritiesBenchmarkSettings(
    requestParameters?: ChangePrioritiesBenchmarkSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v3/master/benchmarks/settings/priorities`,
      accepts: [],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new are.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createAres(
    requestParameters?: CreateAresParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeesAresAre>;
  public createAres(
    requestParameters?: CreateAresParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeesAresAre>>;
  public createAres(
    requestParameters?: CreateAresParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeesAresAre>>;
  public createAres(requestParameters?: CreateAresParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v3/master/ares`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createAre,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new benchmark settings.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createBenchmarkSettings(
    requestParameters?: CreateBenchmarkSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BenchmarkSettings>;
  public createBenchmarkSettings(
    requestParameters?: CreateBenchmarkSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BenchmarkSettings>>;
  public createBenchmarkSettings(
    requestParameters?: CreateBenchmarkSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BenchmarkSettings>>;
  public createBenchmarkSettings(
    requestParameters?: CreateBenchmarkSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v3/master/benchmarks/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createBenchmarkSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a job code and position class assignment for an employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createMercerJobCodeAssignments(
    requestParameters?: CreateMercerJobCodeAssignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerJobCodeAndPositionClassAssignment>;
  public createMercerJobCodeAssignments(
    requestParameters?: CreateMercerJobCodeAssignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerJobCodeAndPositionClassAssignment>>;
  public createMercerJobCodeAssignments(
    requestParameters?: CreateMercerJobCodeAssignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerJobCodeAndPositionClassAssignment>>;
  public createMercerJobCodeAssignments(
    requestParameters?: CreateMercerJobCodeAssignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/mercer-job-codes/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMercerJobCodeAndPositionClassAssignment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates RuleBasedAccessFilter
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: CreateRuleBasedAccessFilterRuleBasedAccessFilterParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RuleBasedAccessFilter>;
  public createRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: CreateRuleBasedAccessFilterRuleBasedAccessFilterParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RuleBasedAccessFilter>>;
  public createRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: CreateRuleBasedAccessFilterRuleBasedAccessFilterParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RuleBasedAccessFilter>>;
  public createRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: CreateRuleBasedAccessFilterRuleBasedAccessFilterParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/rule-based-access-filters`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createRuleBasedAccessFilterCommand,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates new security settings.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSecuritySettings(
    requestParameters?: CreateSecuritySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SecuritySettings>;
  public createSecuritySettings(
    requestParameters?: CreateSecuritySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SecuritySettings>>;
  public createSecuritySettings(
    requestParameters?: CreateSecuritySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SecuritySettings>>;
  public createSecuritySettings(
    requestParameters?: CreateSecuritySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v3/master/employees/security-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createSecuritySettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Deletes an existing are.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteAres(
    requestParameters?: DeleteAresParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteAres(
    requestParameters?: DeleteAresParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteAres(
    requestParameters?: DeleteAresParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteAres(requestParameters?: DeleteAresParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteAres', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v3/master/ares/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * Deletes RuleBasedAccessFilter
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: DeleteRuleBasedAccessFilterRuleBasedAccessFilterParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: DeleteRuleBasedAccessFilterRuleBasedAccessFilterParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: DeleteRuleBasedAccessFilterRuleBasedAccessFilterParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: DeleteRuleBasedAccessFilterRuleBasedAccessFilterParams,
    ...args: RequestArgs
  ): Observable<any> {
    const ruleId = requestParameters?.ruleId;
    this.checkRequired('deleteRuleBasedAccessFilterRuleBasedAccessFilter', { ruleId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/rule-based-access-filters/${this.configuration.encodeParam({ name: 'ruleId', value: ruleId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Deletes existing security settings by their unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSecuritySettings(
    requestParameters?: DeleteSecuritySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteSecuritySettings(
    requestParameters?: DeleteSecuritySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteSecuritySettings(
    requestParameters?: DeleteSecuritySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteSecuritySettings(
    requestParameters?: DeleteSecuritySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteSecuritySettings', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v3/master/employees/security-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * Gets an employee by its unique gid.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employeesAdminGetByGidEmployees(
    requestParameters?: EmployeesAdminGetByGidEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<FullEmployee>;
  public employeesAdminGetByGidEmployees(
    requestParameters?: EmployeesAdminGetByGidEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<FullEmployee>>;
  public employeesAdminGetByGidEmployees(
    requestParameters?: EmployeesAdminGetByGidEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<FullEmployee>>;
  public employeesAdminGetByGidEmployees(
    requestParameters?: EmployeesAdminGetByGidEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const gid = requestParameters?.gid;
    this.checkRequired('employeesAdminGetByGidEmployees', { gid });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/gid/${this.configuration.encodeParam({ name: 'gid', value: gid, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets an employee by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employeesAdminGetEmployees(
    requestParameters?: EmployeesAdminGetEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeesEmployeesEmployee>;
  public employeesAdminGetEmployees(
    requestParameters?: EmployeesAdminGetEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeesEmployeesEmployee>>;
  public employeesAdminGetEmployees(
    requestParameters?: EmployeesAdminGetEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeesEmployeesEmployee>>;
  public employeesAdminGetEmployees(
    requestParameters?: EmployeesAdminGetEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('employeesAdminGetEmployees', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets the employees search scope.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employeesAdminGetScopeEmployees(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public employeesAdminGetScopeEmployees(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public employeesAdminGetScopeEmployees(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public employeesAdminGetScopeEmployees(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/scope`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Queries existing ares by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employeesAdminQueryAres(
    requestParameters?: EmployeesAdminQueryAresParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeesAresAre>;
  public employeesAdminQueryAres(
    requestParameters?: EmployeesAdminQueryAresParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeesAresAre>>;
  public employeesAdminQueryAres(
    requestParameters?: EmployeesAdminQueryAresParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeesAresAre>>;
  public employeesAdminQueryAres(
    requestParameters?: EmployeesAdminQueryAresParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/ares`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        SearchQuery: requestParameters?.searchQuery,
        CountryCode: requestParameters?.countryCode
      }
    });
  }

  /**
   * Queries existing employees.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public employeesAdminQueryEmployees(
    requestParameters?: EmployeesAdminQueryEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public employeesAdminQueryEmployees(
    requestParameters?: EmployeesAdminQueryEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public employeesAdminQueryEmployees(
    requestParameters?: EmployeesAdminQueryEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public employeesAdminQueryEmployees(
    requestParameters?: EmployeesAdminQueryEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Gid: requestParameters?.gid,
        Name: requestParameters?.name,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        PlaceOfAction: requestParameters?.placeOfAction,
        OrgCode: requestParameters?.orgCode,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Exports all advanced benchmarks.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportEmployeeBenchmarkAdvanced(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportEmployeeBenchmarkAdvanced(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeBenchmarkAdvanced(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeBenchmarkAdvanced(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v3/master/employees/benchmarks-advanced/export`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Exports all benchmarks.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportEmployeeBenchmarks(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportEmployeeBenchmarks(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeBenchmarks(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeBenchmarks(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v3/master/employees/benchmarks/export`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportEmployeesExpertsDataEmployeesExperts(
    requestParameters?: ExportEmployeesExpertsDataEmployeesExpertsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportEmployeesExpertsDataEmployeesExperts(
    requestParameters?: ExportEmployeesExpertsDataEmployeesExpertsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeesExpertsDataEmployeesExperts(
    requestParameters?: ExportEmployeesExpertsDataEmployeesExpertsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeesExpertsDataEmployeesExperts(
    requestParameters?: ExportEmployeesExpertsDataEmployeesExpertsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/experts/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { fileName: requestParameters?.fileName, transactionId: requestParameters?.transactionId }
    });
  }

  /**
   * Export MJA data to DataHub
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportJobAssignmentsDatahub(
    requestParameters?: ExportJobAssignmentsDatahubParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public exportJobAssignmentsDatahub(
    requestParameters?: ExportJobAssignmentsDatahubParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public exportJobAssignmentsDatahub(
    requestParameters?: ExportJobAssignmentsDatahubParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public exportJobAssignmentsDatahub(
    requestParameters?: ExportJobAssignmentsDatahubParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/employees/mercer-export/job-assignments`,
      accepts: [],
      query: { exportS3: requestParameters?.exportS3, exportDataHub: requestParameters?.exportDataHub }
    });
  }

  /**
   * Export MJC data to DataHub
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportJobCodesDatahub(
    requestParameters?: ExportJobCodesDatahubParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public exportJobCodesDatahub(
    requestParameters?: ExportJobCodesDatahubParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public exportJobCodesDatahub(
    requestParameters?: ExportJobCodesDatahubParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public exportJobCodesDatahub(requestParameters?: ExportJobCodesDatahubParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/employees/mercer-export/job-codes`,
      accepts: [],
      query: { exportS3: requestParameters?.exportS3, exportDataHub: requestParameters?.exportDataHub }
    });
  }

  /**
   * Exports all assignments.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportMerverJobCodeAssignments(
    requestParameters?: ExportMerverJobCodeAssignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportMerverJobCodeAssignments(
    requestParameters?: ExportMerverJobCodeAssignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportMerverJobCodeAssignments(
    requestParameters?: ExportMerverJobCodeAssignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportMerverJobCodeAssignments(
    requestParameters?: ExportMerverJobCodeAssignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/mercer-job-codes/assignments-export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Gid: requestParameters?.gid,
        Lastname: requestParameters?.lastname,
        Firstname: requestParameters?.firstname,
        OrgCodes: requestParameters?.orgCodes,
        OrgSizes: requestParameters?.orgSizes,
        Countries: requestParameters?.countries,
        AreCodes: requestParameters?.areCodes,
        JobCodes: requestParameters?.jobCodes,
        FamilyNames: requestParameters?.familyNames,
        SubFamilyNames: requestParameters?.subFamilyNames,
        SpecializationNames: requestParameters?.specializationNames,
        CareerLevelNames: requestParameters?.careerLevelNames,
        CareerStreams: requestParameters?.careerStreams,
        PositionClasses: requestParameters?.positionClasses,
        InternalLevels: requestParameters?.internalLevels,
        JobCodeValidFrom: requestParameters?.jobCodeValidFrom,
        JobCodeValidTo: requestParameters?.jobCodeValidTo,
        JobCodeIsValidated: requestParameters?.jobCodeIsValidated,
        PositionClassValidFrom: requestParameters?.positionClassValidFrom,
        PositionClassValidTo: requestParameters?.positionClassValidTo,
        PositionClassIsValidated: requestParameters?.positionClassIsValidated
      },
      body: requestParameters?.createMercerJobCodeAssignmentsExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Gets an existing are by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAres(
    requestParameters?: GetAresParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeesAresAre>;
  public getAres(
    requestParameters?: GetAresParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeesAresAre>>;
  public getAres(
    requestParameters?: GetAresParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeesAresAre>>;
  public getAres(requestParameters?: GetAresParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getAres', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/ares/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets an existing colorado by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getColorados(
    requestParameters?: GetColoradosParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Colorado>;
  public getColorados(
    requestParameters?: GetColoradosParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Colorado>>;
  public getColorados(
    requestParameters?: GetColoradosParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Colorado>>;
  public getColorados(requestParameters?: GetColoradosParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getColorados', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/colorados/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets the count of employees by using provided rule set.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCountEmployees(
    requestParameters?: GetCountEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<number>;
  public getCountEmployees(
    requestParameters?: GetCountEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<number>>;
  public getCountEmployees(
    requestParameters?: GetCountEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<number>>;
  public getCountEmployees(requestParameters?: GetCountEmployeesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/count`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Gets the internal level of an existing employee.
   * will be displayed in details view of mercerJobCode assignments
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeInternalLevel(
    requestParameters?: GetEmployeeInternalLevelParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeInternalLevel>;
  public getEmployeeInternalLevel(
    requestParameters?: GetEmployeeInternalLevelParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeInternalLevel>>;
  public getEmployeeInternalLevel(
    requestParameters?: GetEmployeeInternalLevelParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeInternalLevel>>;
  public getEmployeeInternalLevel(
    requestParameters?: GetEmployeeInternalLevelParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getEmployeeInternalLevel', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/internal-level`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets an existing -available to reorg app- employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeRowLevelSecurity(
    requestParameters?: GetEmployeeRowLevelSecurityParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<FullEmployeeForReorgApp>;
  public getEmployeeRowLevelSecurity(
    requestParameters?: GetEmployeeRowLevelSecurityParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<FullEmployeeForReorgApp>>;
  public getEmployeeRowLevelSecurity(
    requestParameters?: GetEmployeeRowLevelSecurityParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<FullEmployeeForReorgApp>>;
  public getEmployeeRowLevelSecurity(
    requestParameters?: GetEmployeeRowLevelSecurityParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getEmployeeRowLevelSecurity', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/row-level-security/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets an existing employee with compensation data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeWithCompensations(
    requestParameters?: GetEmployeeWithCompensationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<FullEmployee>;
  public getEmployeeWithCompensations(
    requestParameters?: GetEmployeeWithCompensationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<FullEmployee>>;
  public getEmployeeWithCompensations(
    requestParameters?: GetEmployeeWithCompensationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<FullEmployee>>;
  public getEmployeeWithCompensations(
    requestParameters?: GetEmployeeWithCompensationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getEmployeeWithCompensations', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/compensation`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets the internal comment of an existing employee by its unique id.
   * Frontend displays this information in details view of mercer job code assignments.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getInternalComments(
    requestParameters?: GetInternalCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<InternalComment>;
  public getInternalComments(
    requestParameters?: GetInternalCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<InternalComment>>;
  public getInternalComments(
    requestParameters?: GetInternalCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<InternalComment>>;
  public getInternalComments(requestParameters?: GetInternalCommentsParams, ...args: RequestArgs): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getInternalComments', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/internal-comment`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets an existing mercer job code by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMercerJobCodes(
    requestParameters?: GetMercerJobCodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerJobCode>;
  public getMercerJobCodes(
    requestParameters?: GetMercerJobCodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerJobCode>>;
  public getMercerJobCodes(
    requestParameters?: GetMercerJobCodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerJobCode>>;
  public getMercerJobCodes(requestParameters?: GetMercerJobCodesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getMercerJobCodes', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/mercer-job-codes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Get all RuleBasedAccessFilters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRuleBasedAccessFiltersRuleBasedAccessFilter(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<RuleBasedAccessFilter>>;
  public getRuleBasedAccessFiltersRuleBasedAccessFilter(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<RuleBasedAccessFilter>>>;
  public getRuleBasedAccessFiltersRuleBasedAccessFilter(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<RuleBasedAccessFilter>>>;
  public getRuleBasedAccessFiltersRuleBasedAccessFilter(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/rule-based-access-filters`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets the ares search scope.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getScopeAres(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public getScopeAres(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public getScopeAres(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public getScopeAres(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/ares/scope`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets the existing security settings by their unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSecuritySettings(
    requestParameters?: GetSecuritySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SecuritySettings>;
  public getSecuritySettings(
    requestParameters?: GetSecuritySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SecuritySettings>>;
  public getSecuritySettings(
    requestParameters?: GetSecuritySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SecuritySettings>>;
  public getSecuritySettings(requestParameters?: GetSecuritySettingsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getSecuritySettings', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/security-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Queries existing benchmark settings by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryBenchmarkSettings(
    requestParameters?: QueryBenchmarkSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfBenchmarkSettings>;
  public queryBenchmarkSettings(
    requestParameters?: QueryBenchmarkSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfBenchmarkSettings>>;
  public queryBenchmarkSettings(
    requestParameters?: QueryBenchmarkSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfBenchmarkSettings>>;
  public queryBenchmarkSettings(
    requestParameters?: QueryBenchmarkSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/benchmarks/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Gets the assigned JobCodes and PositionClasses for an employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryByEmployeeMercerJobCodeAssignments(
    requestParameters?: QueryByEmployeeMercerJobCodeAssignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerJobCodeAndPositionClassAssignmentLight>;
  public queryByEmployeeMercerJobCodeAssignments(
    requestParameters?: QueryByEmployeeMercerJobCodeAssignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerJobCodeAndPositionClassAssignmentLight>>;
  public queryByEmployeeMercerJobCodeAssignments(
    requestParameters?: QueryByEmployeeMercerJobCodeAssignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerJobCodeAndPositionClassAssignmentLight>>;
  public queryByEmployeeMercerJobCodeAssignments(
    requestParameters?: QueryByEmployeeMercerJobCodeAssignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const gid = requestParameters?.gid;
    this.checkRequired('queryByEmployeeMercerJobCodeAssignments', { gid });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/mercer-job-codes/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Gid: gid }
    });
  }

  /**
   * Queries existing employees.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryBySearchEmployees(
    requestParameters?: QueryBySearchEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfFullEmployee>;
  public queryBySearchEmployees(
    requestParameters?: QueryBySearchEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfFullEmployee>>;
  public queryBySearchEmployees(
    requestParameters?: QueryBySearchEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfFullEmployee>>;
  public queryBySearchEmployees(
    requestParameters?: QueryBySearchEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/query`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size, search: requestParameters?.search }
    });
  }

  /**
   * Queries all directs of an in company manager.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryDirectsInCompanyManagers(
    requestParameters?: QueryDirectsInCompanyManagersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeDirect>;
  public queryDirectsInCompanyManagers(
    requestParameters?: QueryDirectsInCompanyManagersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeDirect>>;
  public queryDirectsInCompanyManagers(
    requestParameters?: QueryDirectsInCompanyManagersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeDirect>>;
  public queryDirectsInCompanyManagers(
    requestParameters?: QueryDirectsInCompanyManagersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/in-company-managers/directs`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Queries all directs of a line manager.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryDirectsLineManagers(
    requestParameters?: QueryDirectsLineManagersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeDirect>;
  public queryDirectsLineManagers(
    requestParameters?: QueryDirectsLineManagersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeDirect>>;
  public queryDirectsLineManagers(
    requestParameters?: QueryDirectsLineManagersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeDirect>>;
  public queryDirectsLineManagers(
    requestParameters?: QueryDirectsLineManagersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/line-managers/directs`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        Search: requestParameters?.search,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Queries all available employees for reorg app.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeRowLevelSecurity(
    requestParameters?: QueryEmployeeRowLevelSecurityParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfFullEmployeeForReorgApp>;
  public queryEmployeeRowLevelSecurity(
    requestParameters?: QueryEmployeeRowLevelSecurityParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfFullEmployeeForReorgApp>>;
  public queryEmployeeRowLevelSecurity(
    requestParameters?: QueryEmployeeRowLevelSecurityParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfFullEmployeeForReorgApp>>;
  public queryEmployeeRowLevelSecurity(
    requestParameters?: QueryEmployeeRowLevelSecurityParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/row-level-security`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Gid: requestParameters?.gid,
        Name: requestParameters?.name,
        OrgCode: requestParameters?.orgCode,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Queries existing employees by provided rule set.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeesEmployees(
    requestParameters?: QueryEmployeesEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public queryEmployeesEmployees(
    requestParameters?: QueryEmployeesEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public queryEmployeesEmployees(
    requestParameters?: QueryEmployeesEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public queryEmployeesEmployees(
    requestParameters?: QueryEmployeesEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v3/master/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.queryEmployeesByRuleSetParameter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Gets all fieldvalues for a specific field.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesEmployees(
    requestParameters?: QueryFieldValuesEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public queryFieldValuesEmployees(
    requestParameters?: QueryFieldValuesEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public queryFieldValuesEmployees(
    requestParameters?: QueryFieldValuesEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public queryFieldValuesEmployees(
    requestParameters?: QueryFieldValuesEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const fieldname = requestParameters?.fieldname;
    this.checkRequired('queryFieldValuesEmployees', { fieldname });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/field-values/${this.configuration.encodeParam({ name: 'fieldname', value: fieldname, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets all fieldvalues for a specific field.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesMercerJobCodeAssignments(
    requestParameters?: QueryFieldValuesMercerJobCodeAssignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesMercerJobCodeAssignments(
    requestParameters?: QueryFieldValuesMercerJobCodeAssignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesMercerJobCodeAssignments(
    requestParameters?: QueryFieldValuesMercerJobCodeAssignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesMercerJobCodeAssignments(
    requestParameters?: QueryFieldValuesMercerJobCodeAssignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('queryFieldValuesMercerJobCodeAssignments', { targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/mercer-job-codes/assignments/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: targetProperty,
        OrgCode: requestParameters?.orgCode,
        OrgSize: requestParameters?.orgSize,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        JobCode: requestParameters?.jobCode,
        JobCodeValidFrom: requestParameters?.jobCodeValidFrom,
        JobCodeValidTo: requestParameters?.jobCodeValidTo,
        FamilyName: requestParameters?.familyName,
        SubFamilyName: requestParameters?.subFamilyName,
        SpecializationName: requestParameters?.specializationName,
        CareerStream: requestParameters?.careerStream,
        CareerLevelName: requestParameters?.careerLevelName,
        JobCodeIsValidated: requestParameters?.jobCodeIsValidated,
        PositionClass: requestParameters?.positionClass,
        PositionClassValidFrom: requestParameters?.positionClassValidFrom,
        PositionClassValidTo: requestParameters?.positionClassValidTo,
        PositionClassIsValidated: requestParameters?.positionClassIsValidated,
        InternalLevel: requestParameters?.internalLevel,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Gets all field values for a specific field.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesMercerJobCodes(
    requestParameters?: QueryFieldValuesMercerJobCodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesMercerJobCodes(
    requestParameters?: QueryFieldValuesMercerJobCodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesMercerJobCodes(
    requestParameters?: QueryFieldValuesMercerJobCodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesMercerJobCodes(
    requestParameters?: QueryFieldValuesMercerJobCodesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('queryFieldValuesMercerJobCodes', { targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/mercer-job-codes/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: targetProperty,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        JobCode: requestParameters?.jobCode,
        Family: requestParameters?.family,
        FamilyEq: requestParameters?.familyEq,
        FamilyCode: requestParameters?.familyCode,
        SubFamily: requestParameters?.subFamily,
        SubFamilyEq: requestParameters?.subFamilyEq,
        SubFamilyCode: requestParameters?.subFamilyCode,
        Specialization: requestParameters?.specialization,
        SpecializationEq: requestParameters?.specializationEq,
        SpecializationCode: requestParameters?.specializationCode,
        CareerStream: requestParameters?.careerStream,
        CareerStreamEq: requestParameters?.careerStreamEq,
        CareerLevel: requestParameters?.careerLevel,
        CareerLevelEq: requestParameters?.careerLevelEq,
        CareerLevelShort: requestParameters?.careerLevelShort,
        CareerLevelShortEq: requestParameters?.careerLevelShortEq,
        PartialJobCode: requestParameters?.partialJobCode,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Gets all field values with descriptions for a specific field.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesWithDescriptionMercerJobCodes(
    requestParameters?: QueryFieldValuesWithDescriptionMercerJobCodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfFieldValueWithDescription>;
  public queryFieldValuesWithDescriptionMercerJobCodes(
    requestParameters?: QueryFieldValuesWithDescriptionMercerJobCodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfFieldValueWithDescription>>;
  public queryFieldValuesWithDescriptionMercerJobCodes(
    requestParameters?: QueryFieldValuesWithDescriptionMercerJobCodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfFieldValueWithDescription>>;
  public queryFieldValuesWithDescriptionMercerJobCodes(
    requestParameters?: QueryFieldValuesWithDescriptionMercerJobCodesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('queryFieldValuesWithDescriptionMercerJobCodes', { targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/mercer-job-codes/field-values-with-description`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: targetProperty,
        'Pageable.Page': requestParameters?.pageablePage,
        'Pageable.Size': requestParameters?.pageableSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        JobCode: requestParameters?.jobCode,
        Family: requestParameters?.family,
        FamilyEq: requestParameters?.familyEq,
        FamilyCode: requestParameters?.familyCode,
        SubFamily: requestParameters?.subFamily,
        SubFamilyEq: requestParameters?.subFamilyEq,
        SubFamilyCode: requestParameters?.subFamilyCode,
        Specialization: requestParameters?.specialization,
        SpecializationEq: requestParameters?.specializationEq,
        SpecializationCode: requestParameters?.specializationCode,
        CareerStream: requestParameters?.careerStream,
        CareerStreamEq: requestParameters?.careerStreamEq,
        CareerLevel: requestParameters?.careerLevel,
        CareerLevelEq: requestParameters?.careerLevelEq,
        CareerLevelShort: requestParameters?.careerLevelShort,
        CareerLevelShortEq: requestParameters?.careerLevelShortEq,
        PartialJobCode: requestParameters?.partialJobCode
      }
    });
  }

  /**
   * Queries all job code values for provided query criteria.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryJobProfileValuesMercerJobCodes(
    requestParameters?: QueryJobProfileValuesMercerJobCodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobProfileValues>;
  public queryJobProfileValuesMercerJobCodes(
    requestParameters?: QueryJobProfileValuesMercerJobCodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobProfileValues>>;
  public queryJobProfileValuesMercerJobCodes(
    requestParameters?: QueryJobProfileValuesMercerJobCodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobProfileValues>>;
  public queryJobProfileValuesMercerJobCodes(
    requestParameters?: QueryJobProfileValuesMercerJobCodesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/mercer-job-codes/job-profile-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        JobCode: requestParameters?.jobCode,
        Family: requestParameters?.family,
        FamilyEq: requestParameters?.familyEq,
        FamilyCode: requestParameters?.familyCode,
        SubFamily: requestParameters?.subFamily,
        SubFamilyEq: requestParameters?.subFamilyEq,
        SubFamilyCode: requestParameters?.subFamilyCode,
        Specialization: requestParameters?.specialization,
        SpecializationEq: requestParameters?.specializationEq,
        SpecializationCode: requestParameters?.specializationCode,
        CareerStream: requestParameters?.careerStream,
        CareerStreamEq: requestParameters?.careerStreamEq,
        CareerLevel: requestParameters?.careerLevel,
        CareerLevelEq: requestParameters?.careerLevelEq,
        CareerLevelShort: requestParameters?.careerLevelShort,
        CareerLevelShortEq: requestParameters?.careerLevelShortEq,
        PartialJobCode: requestParameters?.partialJobCode
      }
    });
  }

  /**
   * Queries all assignments.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMercerJobCodeAssignments(
    requestParameters?: QueryMercerJobCodeAssignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMercerEmployeesWithAssignments>;
  public queryMercerJobCodeAssignments(
    requestParameters?: QueryMercerJobCodeAssignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMercerEmployeesWithAssignments>>;
  public queryMercerJobCodeAssignments(
    requestParameters?: QueryMercerJobCodeAssignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMercerEmployeesWithAssignments>>;
  public queryMercerJobCodeAssignments(
    requestParameters?: QueryMercerJobCodeAssignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/mercer-job-codes/assignments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Gid: requestParameters?.gid,
        Lastname: requestParameters?.lastname,
        Firstname: requestParameters?.firstname,
        OrgCodes: requestParameters?.orgCodes,
        OrgSizes: requestParameters?.orgSizes,
        Countries: requestParameters?.countries,
        AreCodes: requestParameters?.areCodes,
        JobCodes: requestParameters?.jobCodes,
        FamilyNames: requestParameters?.familyNames,
        SubFamilyNames: requestParameters?.subFamilyNames,
        SpecializationNames: requestParameters?.specializationNames,
        CareerLevelNames: requestParameters?.careerLevelNames,
        CareerStreams: requestParameters?.careerStreams,
        PositionClasses: requestParameters?.positionClasses,
        InternalLevels: requestParameters?.internalLevels,
        JobCodeValidFrom: requestParameters?.jobCodeValidFrom,
        JobCodeValidTo: requestParameters?.jobCodeValidTo,
        JobCodeIsValidated: requestParameters?.jobCodeIsValidated,
        PositionClassValidFrom: requestParameters?.positionClassValidFrom,
        PositionClassValidTo: requestParameters?.positionClassValidTo,
        PositionClassIsValidated: requestParameters?.positionClassIsValidated,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * Queries all available mercer job codes.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMercerJobCodes(
    requestParameters?: QueryMercerJobCodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMercerJobCode>;
  public queryMercerJobCodes(
    requestParameters?: QueryMercerJobCodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMercerJobCode>>;
  public queryMercerJobCodes(
    requestParameters?: QueryMercerJobCodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMercerJobCode>>;
  public queryMercerJobCodes(requestParameters?: QueryMercerJobCodesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/mercer-job-codes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        JobCode: requestParameters?.jobCode,
        Family: requestParameters?.family,
        FamilyEq: requestParameters?.familyEq,
        FamilyCode: requestParameters?.familyCode,
        SubFamily: requestParameters?.subFamily,
        SubFamilyEq: requestParameters?.subFamilyEq,
        SubFamilyCode: requestParameters?.subFamilyCode,
        Specialization: requestParameters?.specialization,
        SpecializationEq: requestParameters?.specializationEq,
        SpecializationCode: requestParameters?.specializationCode,
        CareerStream: requestParameters?.careerStream,
        CareerStreamEq: requestParameters?.careerStreamEq,
        CareerLevel: requestParameters?.careerLevel,
        CareerLevelEq: requestParameters?.careerLevelEq,
        CareerLevelShort: requestParameters?.careerLevelShort,
        CareerLevelShortEq: requestParameters?.careerLevelShortEq,
        PartialJobCode: requestParameters?.partialJobCode,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * Gets all existing security settings.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySecuritySettings(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<SecuritySettings>>;
  public querySecuritySettings(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<SecuritySettings>>>;
  public querySecuritySettings(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<SecuritySettings>>>;
  public querySecuritySettings(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v3/master/employees/security-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Recalculate RuleBasedAccessFilter
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateRuleBasedAccessFilterRuleBasedAccessFilter(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<string>;
  public recalculateRuleBasedAccessFilterRuleBasedAccessFilter(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<string>>;
  public recalculateRuleBasedAccessFilterRuleBasedAccessFilter(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<string>>;
  public recalculateRuleBasedAccessFilterRuleBasedAccessFilter(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/rule-based-access-filters/recalculate`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets all existing security settings.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateSecuritySettings(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfEmployeeSecuritySettingsRecalculationMetaData>;
  public recalculateSecuritySettings(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfEmployeeSecuritySettingsRecalculationMetaData>>;
  public recalculateSecuritySettings(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfEmployeeSecuritySettingsRecalculationMetaData>>;
  public recalculateSecuritySettings(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v3/master/employees/security-settings/recalculation`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Queries existing employees by provided criteria, filtered by excluding some gids.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public searchEmployeesEmployees(
    requestParameters?: SearchEmployeesEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public searchEmployeesEmployees(
    requestParameters?: SearchEmployeesEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public searchEmployeesEmployees(
    requestParameters?: SearchEmployeesEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public searchEmployeesEmployees(
    requestParameters?: SearchEmployeesEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v3/master/employees/search`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      },
      body: requestParameters?.queryEmployeesWithExcludableGidsParameter,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendMercerStandingNotification(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public sendMercerStandingNotification(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public sendMercerStandingNotification(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public sendMercerStandingNotification(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/mercer-standing-notification`,
      accepts: []
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendMissingOrganisationInformationNotification(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public sendMissingOrganisationInformationNotification(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public sendMissingOrganisationInformationNotification(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public sendMissingOrganisationInformationNotification(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/missing-organisation-information-notification`,
      accepts: []
    });
  }

  /**
   * Simulates a population of employees based on provided ruleset.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulatePopulationBenchmarkSettings(
    requestParameters?: SimulatePopulationBenchmarkSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public simulatePopulationBenchmarkSettings(
    requestParameters?: SimulatePopulationBenchmarkSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public simulatePopulationBenchmarkSettings(
    requestParameters?: SimulatePopulationBenchmarkSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public simulatePopulationBenchmarkSettings(
    requestParameters?: SimulatePopulationBenchmarkSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('simulatePopulationBenchmarkSettings', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v3/master/benchmarks/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new security settings population simulation.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulatePopulationSecuritySettings(
    requestParameters?: SimulatePopulationSecuritySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PopulationSimulationPage>;
  public simulatePopulationSecuritySettings(
    requestParameters?: SimulatePopulationSecuritySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PopulationSimulationPage>>;
  public simulatePopulationSecuritySettings(
    requestParameters?: SimulatePopulationSecuritySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PopulationSimulationPage>>;
  public simulatePopulationSecuritySettings(
    requestParameters?: SimulatePopulationSecuritySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('simulatePopulationSecuritySettings', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v3/master/employees/security-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-simulation`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Unassign RuleBasedAccessFilter from Employee
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public unassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: UnassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployeeParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public unassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: UnassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployeeParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public unassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: UnassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployeeParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public unassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: UnassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployeeParams,
    ...args: RequestArgs
  ): Observable<any> {
    const ruleId = requestParameters?.ruleId;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('unassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployee', {
      ruleId,
      employeeId
    });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/rule-based-access-filters/${this.configuration.encodeParam({ name: 'ruleId', value: ruleId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Updates an existing are.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateAres(
    requestParameters?: UpdateAresParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeesAresAre>;
  public updateAres(
    requestParameters?: UpdateAresParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeesAresAre>>;
  public updateAres(
    requestParameters?: UpdateAresParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeesAresAre>>;
  public updateAres(requestParameters?: UpdateAresParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v3/master/ares`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateAre,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates existing benchmark settings.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBenchmarkSettings(
    requestParameters?: UpdateBenchmarkSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BenchmarkSettings>;
  public updateBenchmarkSettings(
    requestParameters?: UpdateBenchmarkSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BenchmarkSettings>>;
  public updateBenchmarkSettings(
    requestParameters?: UpdateBenchmarkSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BenchmarkSettings>>;
  public updateBenchmarkSettings(
    requestParameters?: UpdateBenchmarkSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateBenchmarkSettings', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v3/master/benchmarks/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateBenchmarkSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates the employees in company manager and triggers reassignment processing.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeInCompanyManager(
    requestParameters?: UpdateEmployeeInCompanyManagerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public updateEmployeeInCompanyManager(
    requestParameters?: UpdateEmployeeInCompanyManagerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public updateEmployeeInCompanyManager(
    requestParameters?: UpdateEmployeeInCompanyManagerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public updateEmployeeInCompanyManager(
    requestParameters?: UpdateEmployeeInCompanyManagerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('updateEmployeeInCompanyManager', { employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v3/master/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/in-company-manager`,
      accepts: [],
      body: requestParameters?.updateEmployeeInCompanyManager,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates or updates the internal level of an existing employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeInternalLevel(
    requestParameters?: UpdateEmployeeInternalLevelParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeInternalLevel>;
  public updateEmployeeInternalLevel(
    requestParameters?: UpdateEmployeeInternalLevelParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeInternalLevel>>;
  public updateEmployeeInternalLevel(
    requestParameters?: UpdateEmployeeInternalLevelParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeInternalLevel>>;
  public updateEmployeeInternalLevel(
    requestParameters?: UpdateEmployeeInternalLevelParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('updateEmployeeInternalLevel', { employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/master/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/internal-level`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeInternalLevelCommand,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates the employees line manager and triggers reassignment processing.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeLineManager(
    requestParameters?: UpdateEmployeeLineManagerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public updateEmployeeLineManager(
    requestParameters?: UpdateEmployeeLineManagerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public updateEmployeeLineManager(
    requestParameters?: UpdateEmployeeLineManagerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public updateEmployeeLineManager(
    requestParameters?: UpdateEmployeeLineManagerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('updateEmployeeLineManager', { employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v3/master/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/line-manager`,
      accepts: [],
      body: requestParameters?.updateEmployeeLineManager,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Sets the internal comment for an existing employee by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateInternalComments(
    requestParameters?: UpdateInternalCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<InternalComment>;
  public updateInternalComments(
    requestParameters?: UpdateInternalCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<InternalComment>>;
  public updateInternalComments(
    requestParameters?: UpdateInternalCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<InternalComment>>;
  public updateInternalComments(
    requestParameters?: UpdateInternalCommentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('updateInternalComments', { employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/master/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/internal-comment`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateInternalComment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates the job code assignment for an employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMercerJobCodeAssignmentMercerJobCodeAssignments(
    requestParameters?: UpdateMercerJobCodeAssignmentMercerJobCodeAssignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerJobCodeAssignmentLight>;
  public updateMercerJobCodeAssignmentMercerJobCodeAssignments(
    requestParameters?: UpdateMercerJobCodeAssignmentMercerJobCodeAssignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerJobCodeAssignmentLight>>;
  public updateMercerJobCodeAssignmentMercerJobCodeAssignments(
    requestParameters?: UpdateMercerJobCodeAssignmentMercerJobCodeAssignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerJobCodeAssignmentLight>>;
  public updateMercerJobCodeAssignmentMercerJobCodeAssignments(
    requestParameters?: UpdateMercerJobCodeAssignmentMercerJobCodeAssignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    const id = requestParameters?.id;
    this.checkRequired('updateMercerJobCodeAssignmentMercerJobCodeAssignments', { employeeId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/mercer-job-codes/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/job-code/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMercerJobCodeAssignment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates the position class assignment for an employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMercerPositionClassAssignmentMercerJobCodeAssignments(
    requestParameters?: UpdateMercerPositionClassAssignmentMercerJobCodeAssignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerPositionClassAssignmentLight>;
  public updateMercerPositionClassAssignmentMercerJobCodeAssignments(
    requestParameters?: UpdateMercerPositionClassAssignmentMercerJobCodeAssignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerPositionClassAssignmentLight>>;
  public updateMercerPositionClassAssignmentMercerJobCodeAssignments(
    requestParameters?: UpdateMercerPositionClassAssignmentMercerJobCodeAssignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerPositionClassAssignmentLight>>;
  public updateMercerPositionClassAssignmentMercerJobCodeAssignments(
    requestParameters?: UpdateMercerPositionClassAssignmentMercerJobCodeAssignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    const id = requestParameters?.id;
    this.checkRequired('updateMercerPositionClassAssignmentMercerJobCodeAssignments', { employeeId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/master/mercer-job-codes/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/position-class/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMercerPositionClassAssignment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates RuleBasedAccessFilter
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: UpdateRuleBasedAccessFilterRuleBasedAccessFilterParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RuleBasedAccessFilter>;
  public updateRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: UpdateRuleBasedAccessFilterRuleBasedAccessFilterParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RuleBasedAccessFilter>>;
  public updateRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: UpdateRuleBasedAccessFilterRuleBasedAccessFilterParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RuleBasedAccessFilter>>;
  public updateRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: UpdateRuleBasedAccessFilterRuleBasedAccessFilterParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/rule-based-access-filters`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateRuleBasedAccessFilterCommand,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates existing security settings by their unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSecuritySettings(
    requestParameters?: UpdateSecuritySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SecuritySettings>;
  public updateSecuritySettings(
    requestParameters?: UpdateSecuritySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SecuritySettings>>;
  public updateSecuritySettings(
    requestParameters?: UpdateSecuritySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SecuritySettings>>;
  public updateSecuritySettings(
    requestParameters?: UpdateSecuritySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateSecuritySettings', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v3/master/employees/security-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSecuritySettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
